/* ============================================================
   Treverket — alt JavaScript på sida.

   Mykje mindre enn i forhandsvisinga, fordi Shopify no gjer det
   meste sjølv:
     ruting      – ekte URL-ar, ingen hash-router
     filtrering  – Shopify sine server-side filter, ingen DOM-jobb
     søk         – /search, ingen klientside-indeks
     tekst       – seksjonsinnstillingar og sider i admin

   Det som står att: mørk modus, og korga som skuff.
   ============================================================ */
(() => {
  'use strict';

  const rutar = (window.Treverket && window.Treverket.rutar) || {};
  const SEKSJON = 'korg-skuff';

  // ---- Mørk modus ------------------------------------------------------
  const LYS = 'havre';
  const MORK = 'kveld';
  const MORKNOKKEL = 'treverket-mork';

  function settMorkmodus(pa, lagre = true) {
    document.documentElement.dataset.palett = pa ? MORK : LYS;
    document.querySelectorAll('[data-morkmodus]').forEach((b) => {
      b.setAttribute('aria-pressed', String(pa));
    });
    if (lagre) localStorage.setItem(MORKNOKKEL, pa ? '1' : '0');
  }

  const lagra = localStorage.getItem(MORKNOKKEL);
  if (lagra !== null) {
    settMorkmodus(lagra === '1', false);
  } else if (document.documentElement.dataset.palett === MORK) {
    settMorkmodus(true, false);
  }

  document.addEventListener('click', (ev) => {
    const knapp = ev.target.closest('[data-morkmodus]');
    if (!knapp) return;
    settMorkmodus(document.documentElement.dataset.palett !== MORK);
  });

  // ---- Korga -----------------------------------------------------------
  function skuff() {
    return document.querySelector('[data-korg-skuff]');
  }

  function opne() {
    const d = skuff();
    if (d && !d.open) d.showModal();
  }

  function varsle(tekst) {
    let el = document.querySelector('[data-varsel]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'varsel';
      el.setAttribute('data-varsel', '');
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.append(el);
    }
    el.textContent = tekst;
    el.dataset.vis = 'ja';
  }

  /* Kvart korg-kall ber Shopify rendre skuffa på nytt i same svar
     (bundled section rendering), så malen finst berre éin stad — i Liquid.

     Svaret inneheld seksjonen MED omslags-diven. Difor replaceWith på
     heile elementet, ikkje innerHTML — innerHTML la omslaget inni det
     gamle, gav to element med same id, og skuffa slutta å oppdatere seg. */
  function byttSkuff(html, { opneEtterpa = false } = {}) {
    const vert = document.getElementById(`shopify-section-${SEKSJON}`);
    if (!vert || !html) return;
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const ny = tmp.querySelector(`#shopify-section-${SEKSJON}`) || tmp.firstElementChild;
    if (!ny) return;

    /* Er skuffa alt open, byter vi berre innhaldet i dialogen. Då står
       elementet og open-tilstanden i ro, og opningsanimasjonen køyrer
       ikkje om att for kvar endring. */
    const gamal = skuff();
    const nyDialog = ny.querySelector('[data-korg-skuff]');
    if (gamal && gamal.open && nyDialog) {
      gamal.innerHTML = nyDialog.innerHTML;
      return;
    }
    vert.replaceWith(ny);
    if (opneEtterpa) opne();
  }

  async function endreLinje(linje, tal) {
    const svar = await fetch(`${rutar.endre}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: linje, quantity: tal, sections: SEKSJON })
    });
    const data = await svar.json().catch(() => ({}));
    if (!svar.ok) throw new Error(data.description || 'Kunne ikkje oppdatere korga.');
    byttSkuff(data.sections && data.sections[SEKSJON]);
    oppdaterTal();
  }

  async function oppdaterTal() {
    const svar = await fetch(`${rutar.korg}.js`, { headers: { Accept: 'application/json' } });
    if (!svar.ok) return;
    const korg = await svar.json();
    document.querySelectorAll('[data-korgtal]').forEach((el) => {
      el.textContent = korg.item_count;
      el.dataset.korgtal = korg.item_count;
    });
  }

  // Legg i korga uten å forlate sida.
  document.addEventListener('submit', async (ev) => {
    const skjema = ev.target;
    if (!skjema.querySelector('[data-legg-i-korg]')) return;
    ev.preventDefault();
    const knapp = skjema.querySelector('[data-legg-i-korg]');
    knapp.disabled = true;
    try {
      const skjemadata = new FormData(skjema);
      skjemadata.append('sections', SEKSJON);
      const svar = await fetch(`${rutar.leggTil}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: skjemadata
      });
      const data = await svar.json().catch(() => ({}));
      if (!svar.ok) {
        throw new Error(data.description || 'Kunne ikkje leggje varen i korga.');
      }
      byttSkuff(data.sections && data.sections[SEKSJON], { opneEtterpa: true });
      oppdaterTal();
    } catch (f) {
      // Fell tilbake til vanleg innsending, så kunden ikkje står fast.
      varsle(f.message);
      skjema.submit();
    } finally {
      knapp.disabled = false;
    }
  });

  // Fjern ei linje.
  document.addEventListener('click', async (ev) => {
    const knapp = ev.target.closest('[data-fjern]');
    if (!knapp) return;
    ev.preventDefault();
    knapp.disabled = true;
    try {
      await endreLinje(Number(knapp.dataset.fjern), 0);
    } catch (f) {
      varsle(f.message);
      knapp.disabled = false;
    }
  });

  // Antalsknappane i skuffa. Minus på 1 fjernar linja.
  document.addEventListener('click', async (ev) => {
    const knapp = ev.target.closest('[data-mengd]');
    if (!knapp) return;
    ev.preventDefault();
    const no = Number(knapp.closest('.korg__mengd').querySelector('span').textContent);
    const nytt = Math.max(0, no + Number(knapp.dataset.steg));
    knapp.disabled = true;
    try {
      await endreLinje(Number(knapp.dataset.mengd), nytt);
    } catch (f) {
      varsle(f.message);
      knapp.disabled = false;
    }
  });

  // Korgknappen i toppen opnar skuffa, men er ei ekte lenke til /cart
  // så ho virkar utan JavaScript.
  document.addEventListener('click', (ev) => {
    const knapp = ev.target.closest('[data-opne-korg]');
    if (!knapp) return;
    ev.preventDefault();
    opne();
  });

  document.addEventListener('click', (ev) => {
    if (ev.target.closest('[data-lukk-korg]')) skuff()?.close();
  });

  // Klikk på bakgrunnen lukkar. <dialog> tek Escape og fokusfella sjølv.
  document.addEventListener('click', (ev) => {
    const d = skuff();
    if (!d || !d.open || ev.target !== d) return;
    d.close();
  });

  // ---- Talet på filterknappen ------------------------------------------
  function telFilter() {
    const knapp = document.querySelector('.filterknapp');
    if (!knapp) return;
    // Kategoriane tel med når dei er eit fleirvalsfilter. I fallback-modus er
    // dei berre navigasjon, og då står dei med aria-current="page" i staden.
    const aktive = document.querySelectorAll(
      '.filtersidebar .chip[data-valt="true"], ' +
      '.filtersidebar .filterkat[data-valt="true"][aria-current="true"]'
    ).length;
    knapp.dataset.tal = String(aktive);
    const boble = knapp.querySelector('.filterknapp__tal');
    if (boble) boble.textContent = aktive > 0 ? String(aktive) : '';
  }
  telFilter();

  // ---- Biletgalleriet på produktsida -----------------------------------
  // Miniatyrane byter ut hovudbiletet. Server-side rendering gjev det fyrste
  // biletet, så her trengst berre bytet.
  // Delegert på document, ikkje bunde til .galleri__mini. Variantbytet under
  // byter ut heile produktseksjonen, og ein lyttar på elementet hadde forsvunne
  // med det gamle galleriet.
  document.addEventListener('click', (ev) => {
    // Berre <button>. Miniatyrar som høyrer til ein variant er <a>, og dei
    // skal velje varianten, ikkje berre bytte biletet.
    const knapp = ev.target.closest('button.galleri__mini-knapp');
    if (!knapp || knapp.getAttribute('aria-pressed') === 'true') return;

    const mini = knapp.closest('.galleri__mini');
    const stor = mini && mini.closest('.galleri').querySelector('.galleri__stor');
    if (!stor) return;

    // srcset fyrst: då veljer nettlesaren rett breidde med ein gong, i
    // staden for å laste 1100px og byte etterpå.
    stor.srcset = knapp.dataset.srcset || '';
    stor.src = knapp.dataset.stor || '';
    stor.alt = knapp.dataset.alt || '';

    mini.querySelectorAll('.galleri__mini-knapp').forEach((k) => {
      k.setAttribute('aria-pressed', String(k === knapp));
    });
  });

  // ---- Variantbyte utan omlasting --------------------------------------
  /* Lenkene står urørte i Liquid, med ?variant=. Utan JS lastar sida som før,
     og lenka kan framleis delast. Med JS hentar vi berre produktseksjonen og
     byter han ut, så kunden blir ståande der han er.

     Same mønster som korga over, og same fella: svaret inneheld seksjonen MED
     omslags-diven, så det må vere replaceWith på heile elementet. innerHTML
     ville lagt omslaget inni det gamle og gitt to element med same id.

     Seksjons-id-en blir lesen av DOM-en, ikkje hardkoda, så malen kan døypast
     om i editoren utan at dette ryk. */
  async function byttProduktseksjon(url) {
    const vert = document.querySelector('.variantar')?.closest('[id^="shopify-section-"]');
    if (!vert) throw new Error('fann ingen produktseksjon');

    const hent = new URL(url, location.href);
    hent.searchParams.set('section_id', vert.id.replace('shopify-section-', ''));

    const svar = await fetch(hent, { headers: { Accept: 'text/html' } });
    if (!svar.ok) throw new Error(svar.status);

    const tmp = document.createElement('div');
    tmp.innerHTML = await svar.text();
    const ny = tmp.querySelector(`#${CSS.escape(vert.id)}`) || tmp.firstElementChild;
    if (!ny) throw new Error('fann ikkje seksjonen i svaret');

    vert.replaceWith(ny);
    return ny;
  }

  document.addEventListener('click', async (ev) => {
    const lenke = ev.target.closest('.variantar a, .galleri__mini a');
    if (!lenke) return;
    // Lat nettlesaren gjere sitt ved midtklikk og modifikator-klikk, så
    // «opne i ny fane» framleis verkar.
    if (ev.defaultPrevented || ev.button !== 0 ||
        ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
    if (!document.querySelector('.variantar')?.closest('[id^="shopify-section-"]')) return;

    ev.preventDefault();
    try {
      const ny = await byttProduktseksjon(lenke.href);
      history.pushState({ variant: true }, '', lenke.href);
      // Flytt fokus til den valde chipen, elles blir tastaturbrukaren ståande
      // på eit element som ikkje finst lenger. preventScroll, så sida ikkje hoppar.
      ny.querySelector('.variantar a[aria-current="true"]')?.focus({ preventScroll: true });
    } catch {
      location.href = lenke.href; // fell tilbake til vanleg navigering
    }
  });

  // Tilbakeknappen skal framleis gå mellom variantane, slik han gjorde då
  // kvart val var ei full omlasting.
  window.addEventListener('popstate', async () => {
    if (!document.querySelector('.variantar')) return;
    try { await byttProduktseksjon(location.href); }
    catch { location.reload(); }
  });
})();
